import { Outlet } from 'react-router-dom';
import { RequireAdminAuth } from '@/platform/auth/require-dashboard-auth';
import { AppShell } from '@/platform/layout/app-shell';

export function AdminLayout() {
  return (
    <RequireAdminAuth>
      <AppShell>
        <Outlet />
      </AppShell>
    </RequireAdminAuth>
  );
}
